// extracted by mini-css-extract-plugin
export default {"link":"LinkButton_link__p0nxY","under_text":"LinkButton_under_text__UeMRG"};